<template lang="pug">
  main
    NavBarRequisicion
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 Nueva Base De Artículo &nbsp
              |
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-12
            FormArticulos_Base(@saveForm="saveForm")
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarRequisicion from './layout/NavBarRequisicion.vue'
  import FormArticulos_Base from './FormArticulos_Base.vue'

  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'NuevoArticulo_Base',
    components: { Loader, NavBarRequisicion, FormArticulos_Base },
    data() {
      return {
        isLoading: true
      }
    },
    methods: {
      iniciarComponente() {
        setTimeout(() => {
          this.isLoading = false
        }, 350)
      },
      saveForm (data) {
        this.isLoading = true
        InventarioServices.addBaseArticulo(data.id_cat, data.categoria, data.id_subcat, data.subcategoria, data.marca, data.modelo, data.codigo)
          .then((resp) => {
            console.log(resp)
            if (resp.respuesta) {
              this.displayToast(resp.respuesta, 'done', 'Ok')
              this.$router.push('/Inventario/Articulos')
            } else {
              this.displayToast(resp.respuesta, 'ban', 'Ok')
            }
          })
          .catch((error) => console.error(error.message))
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backPage() {
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/NuevoArticulo_Base.vue